import { FunctionComponent } from 'react';

import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageAboutSectionHeroDescription: FunctionComponent<Props> = ({
    translations: { description },
}) => {
    return (
        <StyledComponent
            className="public-page-about-section-hero-description"
        >
            <LayoutContainer>
                <div
                    className="description"
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageAboutSectionHeroDescription;